import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { Editor, Range } from 'slate';
import generateLinkElement from '../element-model/link';
import generateImageElement from '../element-model/image';
import generateColumn from '../element-model/column';
import EditorContext from '../editor-context';
var withInline = function withInline(editor) {
  var exec = editor.exec,
    isInline = editor.isInline;
  editor.isInline = function (element) {
    var inlineElementTypes = ['link', 'image', 'column'];
    return inlineElementTypes.includes(element.type) || isInline(element);
  };
  editor.exec = function (command) {
    var data = command.data;
    var selection = editor.selection;
    switch (command.type) {
      case 'insert_link_at_selection':
        selection = command.elementData.selection;
        var isCollapsed = selection && Range.isCollapsed(selection);
        var link = generateLinkElement({
          type: 'link',
          children: [{
            text: command.elementData.text
          }],
          data: {
            href: command.elementData.url
          }
        });
        if (isCollapsed) {
          Editor.insertNodes(editor, link, {
            at: selection
          });
        } else {
          Editor.wrapNodes(editor, link, {
            split: true,
            at: selection
          });
          Editor.select(editor, selection);
          Editor.collapse(editor, {
            edge: 'end'
          });
        }
        break;
      case 'unwrap_link':
        Editor.unwrapNodes(editor, {
          match: {
            type: 'link'
          }
        });
        break;
      case 'set_link':
        selection = command.elementData.selection;
        Editor.removeNodes(editor, {
          match: {
            type: 'link'
          },
          at: selection
        });
        var newNodeLink = generateLinkElement({
          type: 'link',
          data: {
            href: command.elementData.url
          },
          children: [{
            text: command.elementData.text
          }]
        });
        // Insert a new link at previous link path
        var linkPath = _toConsumableArray(selection.anchor.path);
        linkPath.pop();
        Editor.insertNodes(editor, newNodeLink, {
          at: linkPath
        });
        break;
      case 'insert_image_at_selection':
        var img = generateImageElement({
          data: command.data
        });
        Editor.insertNodes(editor, img, {
          at: command.at
        });
        break;
      case 'set_image':
        Editor.setNodes(editor, {
          data: data
        }, {
          match: {
            type: 'image'
          },
          at: editor.selection,
          voids: true
        });
        break;
      case 'insert_data':
        var _EditorContext$getEdi = EditorContext.getEditor(),
          editorApi = _EditorContext$getEdi.editorApi;
        if (data.types.includes('Files') && data.files[0].type.includes('image') && editorApi.uploadLocalImage) {
          editorApi.uploadLocalImage(command.data.files[0]).then(function (res) {
            var img = generateImageElement({
              data: {
                src: res
              }
            });
            Editor.insertNodes(editor, img);
          });
          return;
        }
        exec(command);
        break;
      case 'insert_seatable_column':
        var column = generateColumn({
          type: 'column'
        });
        Editor.insertNodes(editor, column);
        break;
      case 'set_seatable_column':
        Editor.setNodes(editor, {
          data: data
        }, {
          match: {
            type: 'column'
          },
          at: editor.selection
        });
        break;
      default:
        exec(command);
        break;
    }
  };
  return editor;
};
export default withInline;